import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { INotification } from '../components/features/Notifications/INotification';

type NotificationState = {
  notifications: INotification[];
  seenIds: string[];
  setNotifications: (items: INotification[]) => void;
  markAllRead: () => void;
  reset: () => void;
};

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set, get) => ({
      notifications: [],
      seenIds: [],

      setNotifications: (items) => {
        set({ notifications: items });
      },

      markAllRead: () => {
        const currentIds = get()
          .notifications.map((n) => n.id)
          .filter((id): id is string => Boolean(id));
        if (currentIds.length === 0) return;
        set({
          seenIds: Array.from(new Set([...get().seenIds, ...currentIds])),
        });
      },

      reset: () => set({ notifications: [], seenIds: [] }),
    }),
    {
      name: 'notifications',
      partialize: (s) => ({ seenIds: s.seenIds }),
    }
  )
);
